module.exports = __webpack_public_path__ + "static/slide6-743x573-954a150ff03c3fef03704bba77b5bd0c.gif";